<template>
  <div class="container py-8 px-10 bg-white shadow-md rounded-lg">
    <slot />
  </div>
</template>

<script>

export default {
  // Component Definition
};

</script>

<style lang="scss" scoped>

 .container {
   min-height: 35rem;
 }

</style>
